import axios from '../utils/axios';

export default function fetchCronJobs(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/cron/jobs', { params })
    )
}
